import React from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

export default function ModeTileSmall({
  to,
  title,
  desc,
  img = null,
  onClick,
  disabled = false,
}) {
  const { t } = useTranslation();

  const baseClass = `relative primary-button w-full flex items-center justify-center ${
    disabled ? "opacity-70 pointer-events-none" : ""
  }`;

  const inner = (
    <>
      {img ? (
        <span className="absolute left-4 top-1/2 -translate-y-1/2 w-6 h-6 flex items-center justify-center pointer-events-none text-greyscale-1 fill-greyscale-1">
          {img}
        </span>
      ) : null}

      {/* Reserve space for icon on BOTH sides so centered text stays centered */}
      <div className="w-full px-12 flex flex-col items-center text-center">
        <p className="subtitle-text">{title}</p>
        {desc ? <p className="text-sm text-greyscale-2">{desc}</p> : null}
        {disabled ? (
          <div className="opacity-60">
            {t("levelSelection.notSupportedCta")}
          </div>
        ) : null}
      </div>
    </>
  );

  if (disabled) {
    return (
      <button type="button" className={baseClass} disabled>
        {inner}
      </button>
    );
  }

  if (!to) {
    return (
      <button type="button" className={baseClass} onClick={onClick}>
        {inner}
      </button>
    );
  }

  return (
    <Link to={to} className={baseClass} onClick={onClick}>
      {inner}
    </Link>
  );
}
